<template>
  <svg width="80" height="40" viewBox="0 0 80 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="80" height="40" rx="4" fill="#F8F9FA"/>
    <rect x="8" y="8" width="64" height="8" rx="2" fill="#EEEEEE"/>
    <rect width="16" height="8" transform="translate(8 8)" fill="#B4BFCB"/>
    <rect x="12" y="11" width="8" height="2" rx="1" fill="white"/>
    <rect x="28" y="11" width="8" height="2" rx="1" fill="#B4BFCB"/>
    <rect x="44" y="11" width="8" height="2" rx="1" fill="#B4BFCB"/>
    <mask id="path-6-inside-1_13997_26133" fill="white">
      <path d="M8 22C8 20.8954 8.89543 20 10 20H70C71.1046 20 72 20.8954 72 22V32H8V22Z"/>
    </mask>
    <path d="M7 22C7 20.3431 8.34315 19 10 19H70C71.6569 19 73 20.3431 73 22H71C71 21.4477 70.5523 21 70 21H10C9.44772 21 9 21.4477 9 22H7ZM72 32H8H72ZM7 32V22C7 20.3431 8.34315 19 10 19V21C9.44772 21 9 21.4477 9 22V32H7ZM70 19C71.6569 19 73 20.3431 73 22V32H71V22C71 21.4477 70.5523 21 70 21V19Z" fill="#B4BFCB" mask="url(#path-6-inside-1_13997_26133)"/>
    <rect x="12" y="24" width="13" height="2" rx="1" fill="#DEE3E6"/>
    <rect x="12" y="28" width="49" height="2" rx="1" fill="#DEE3E6"/>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
